<template>
  <v-dialog v-model="c_dialog" width="960">
    <v-card>

      <v-toolbar class="primary white--text" flat dark>
        <v-toolbar-title>Actualizare în masă de inventar</v-toolbar-title>
        <v-spacer/>
        <v-btn icon @click="c_dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-1">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="subtitle-1 font-weight-bold ma-1">
              Contract
            </div>
          </v-col>
          <v-col cols="12" v-if="contract">
            <v-row no-gutters align="center">
              <v-btn depressed small color="primary" class="ma-1">{{contract.text}}<small class="ml-1">({{contract.value}})</small></v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <div class="subtitle-1 font-weight-bold ma-1">
              Camere
            </div>
          </v-col>
          <v-col cols="12">
            <v-row no-gutters align="center">
              <v-item-group v-model="c_selected_rooms" multiple>
                <v-item v-for="room in c_available_rooms" v-slot:default="{ active, toggle }" :value="room.id" :key="room.id">
                  <v-btn depressed small :color="active ? 'primary' : ''" class="ma-1" @click="toggle">{{room.name}}<small class="ml-1">({{room.id}})</small></v-btn>
                </v-item>
              </v-item-group>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters v-if="c_selected_rooms && c_selected_rooms.length">
          <v-col cols="12">
            <div class="subtitle-1 font-weight-bold ma-1">
              Interval
            </div>
          </v-col>
          <v-col cols="12">
            <v-menu v-model="menu" :close-on-content-click="false" transition="fade-transition" offset-y max-width="512">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="c_label" v-on="on" dense class="ma-1" label="Interval" outlined readonly hide-details/>
              </template>
              <v-card tile flat>
                <im-date-picker v-model="c_value" mode="range" locale="ro" is-inline style="border-width: 0;" :columns="2"/>
                <v-divider class="mx-2"/>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn depressed color="primary" @click="menu=false">
                    Ok
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-col>
          <v-col cols="12">
            <v-row no-gutters align="center">
              <v-item-group v-model="days" multiple>
                <v-item v-for="day in weekdays" v-slot:default="{ active, toggle }" :key="day">
                  <v-btn depressed small :color="active ? 'primary' : ''" class="ma-1" @click="toggle">{{day}}</v-btn>
                </v-item>
              </v-item-group>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters v-if="c_selected_rooms && c_selected_rooms.length && days.length">
          <v-col cols="12">
            <div class="subtitle-1 font-weight-bold ma-1">
              Valori
            </div>
          </v-col>
          <v-col cols="12">
            <v-row no-gutters>
              <v-col cols="3">
                <div class="ma-1">
                  <v-btn :class="{primary: !available_read_only}" depressed block style="height: 40px" @click="available_read_only = !available_read_only; available = null">
                    Disponibilitate
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="9">
                <v-text-field v-model="available" :disabled="available_read_only" class="ma-1" label="Disponibilitate" outlined dense type="number" hide-details/>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row no-gutters>
              <v-col cols="3">
                <div class="ma-1">
                  <v-btn :class="{primary: !close_out_read_only}" depressed block style="height: 40px" @click="close_out_read_only = !close_out_read_only; close_out = null">
                    Restrictii
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="9">
                <v-select v-model="close_out" label="Restrictii" outlined dense hide-details class="ma-1" :disabled="close_out_read_only" :items="[{text: 'Deschis', value: false}, {text: 'Inchis', value: true}]"/>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row no-gutters>
              <v-col cols="3">
                <div class="ma-1">
                  <v-btn :class="{primary: !release_read_only}" depressed block style="height: 40px" @click="release_read_only = !release_read_only; release = null">
                    Release
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="9">
                <v-text-field v-model="release" :disabled="release_read_only" class="ma-1" label="Release" outlined dense type="number" hide-details/>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="mx-2"/>

      <v-card-actions>
        <v-btn color="primary" text @click="c_dialog = false">
          Anuleaza
        </v-btn>
        <v-spacer/>
        <v-btn
          color="primary"
          depressed
          :loading="loading"
          :disabled="((!close_out && !available && !release) || !days.length) || loading"
          @click="update"
        >
          Salveaza
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>


<script>

  import moment from 'moment';
  import sheet_repository from '@/repositories/sheet-repository';

  export default {
    props: {
      dialog: Boolean,
      rooms: Object,
      room: Array,
      contract: Object
    },

    data() {
      return {
        loading: false,
        menu: null,

        selected_rooms: this.room,
        available_rooms: this.rooms,

        available: null,
        available_read_only: true,

        close_out: null,
        close_out_read_only: true,

        release: null,
        release_read_only: true,

        days: [0, 1, 2, 3, 4],
        weekdays: ['Lun', 'Mar', 'Mie', 'Joi', 'Vin', 'Sâm', 'Dum'],
        from: moment().format('YYYY-MM-DD'),
        until: moment().add(1, 'days').format('YYYY-MM-DD'),
      }
    },

    computed: {

      c_dialog: {
        get() {
          return this.dialog;
        },
        set(val) {
          this.$emit('update:dialog', val);
        }
      },

      c_value: {
        get() {
          return {
            start: new Date(this.from),
            end: new Date(this.until)
          };
        },
        set(val) {
          this.from = this.$moment(val.start).format('YYYY-MM-DD');
          this.until = this.$moment(val.end).format('YYYY-MM-DD');
        }
      },

      c_label: function () {
        return this.$moment(this.c_value.start).format('LL') + ' ➞ ' + this.$moment(this.c_value.end).format('LL')
      },

      c_selected_rooms: {
        get() {
          return this.selected_rooms;
        },
        set(value) {
          this.selected_rooms = value;
        }
      },

      c_available_rooms: {
        get() {
          return this.available_rooms;
        }
      }

    },

    methods: {
      update: async function () {
        let hotel = this.$route.params.hotel;
        let data = {
          period: {
            start: this.from,
            stop: this.until,
            weekdays: this.days
          },
          rooms_contracts: this.getRoomsContracts(),
          changes: {}
        };

        if (this.available)
          data.changes.available = this.available;

        if (this.close_out)
          data.changes.close_out = this.close_out;

        if (this.release)
          data.changes.release = this.release;

        try {
          this.loading = true;
          await sheet_repository.bulkUpdateInventory(hotel, data);
          this.$emit('success');
        } catch (e) {
          this.$emit('error');
        } finally {
          this.loading = false
        }

      },

      resetDialog() {
        this.selected_rooms = this.room;
        this.available_rooms = this.rooms;

        this.available = null;
        this.available_read_only = true;

        this.close_out = null;
        this.close_out_read_only = true;

        this.release = null;
        this.release_read_only = true;

        this.days = [0, 1, 2, 3, 4];
        this.from = moment().format('YYYY-MM-DD');
        this.until = moment().add(1, 'days').format('YYYY-MM-DD');
      },

      getRoomsContracts() {
        let rooms_contracts = {};
        Object.entries(this.rooms).forEach(([key, room]) => {
          this.selected_rooms.forEach(selected_room => {
            if (parseInt(selected_room) === parseInt(room.id)) {
              rooms_contracts[selected_room] = rooms_contracts[selected_room] || [];
              rooms_contracts[selected_room].push(this.contract.value);
            }
          });
        });

        return rooms_contracts;
      },
    }
  }
</script>